<template>
	<div :class="`fixed inset-x-0 ${position}-0 flex justify-center z-30`">
		<div class="message" :class="classMessage">
			<x-icon class="close" v-if="!autoClose" @click="close"></x-icon>
			<div class="icon">
				<component class="w-12 h-12 text-white" :is="messageIcon"></component>
			</div>
			<div class="">
				<h4 v-if="message.title">{{ message.title }}</h4>
				{{ message.message }}
			</div>

		</div>
	</div>
</template>

<script>
import { CheckIcon, XIcon, InfoIcon } from 'vue-feather-icons'
export default {
	props: {
		message: Object,
		autoClose: {
			type: Boolean,
			default: true
		},
		timeOut: {
			type: Number,
			default: 3
		}
	},
	data () {
		return {
			position: this.message.position ? this.message.position : 'bottom'
		}
	},
	name: 'FlashMessage',
	components: {
		CheckIcon,
		XIcon,
		InfoIcon
	},
	methods: {
		close: function () {
			this.$store.commit('clearStatus')
		}
	},
	computed: {
		classMessage: function () {
			return 'message-' + this.message.type
		},
		messageIcon: function () {
			if (this.message.type === 'info') { };
			if (this.message.type === 'error') { return 'XIcon' };
			if (this.message.type === 'success') { return 'CheckIcon' };
			return 'InfoIcon'
		}
	},
	created: function () {
		const escapeHandler = e => {
			if (e.key === 'Escape') {
				this.close()
			}
		}
		document.addEventListener('keydown', escapeHandler)
		this.$once('hook:destroyed', () => {
			document.removeEventListener('keydown', escapeHandler)
		})
		if (this.autoClose) {
			setTimeout(this.close, 5000)
		}
	}
}
</script>

<style lang="css" scoped>
.message {
	@apply flex items-center w-full shadow px-4 py-2 rounded bg-white m-16 pl-12 relative;
}
@screen md {
  .message {
    @apply w-1/3;
  }
}
.icon{
	@apply rounded-full absolute left-0 p-1 bg-gray-600;
	left: -30px;
}
.message-info {
	@apply bg-blue-100;
}
.message-success {
	@apply bg-green-100;
}
.message-error {
	@apply bg-red-100;
}
.message h4 {
	@apply text-xl font-bold;
}
.message-info h4 {
	@apply text-blue-500;
}
.message-error h4 {
	@apply text-red-500;
}
.message-info .icon {
	@apply bg-blue-500;
}
.message-error .icon {
	@apply bg-red-500;
}
.message-success .icon {
	@apply bg-green-500;
}
.close{
	@apply rounded-full absolute top-0 right-0 p-1 h-6 w-6 text-gray-600 bg-white cursor-pointer shadow;
	right: -10px;
	top: -10px;
}
.close:hover{
	@apply bg-gray-200;
}
</style>
